import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const HouseholdExpensesChartsDataContext = createContext();

const HouseholdExpensesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.HOUSEHOLD_EXPENSES_FAMILIES,
            url: 'governanceroom/dashboard/unifiedregistry/families/household-expenses'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              alimentation: data?.alimentation ?? [],
              eletricEnergy: data?.eletricEnergy ?? [],
              familyExpenses: data?.familyExpenses ?? [],
              gas: data?.gas ?? [],
              medications: data?.medications ?? [],
              rent: data?.rent ?? [],
              transportation: data?.transportation ?? [],
              waterAndSewage: data?.waterAndSewage ?? []
          }
        : {
              alimentation: [],
              eletricEnergy: [],
              familyExpenses: [],
              gas: [],
              medications: [],
              rent: [],
              transportation: [],
              waterAndSewage: []
          };

    return (
        <HouseholdExpensesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </HouseholdExpensesChartsDataContext.Provider>
    );
};

export default HouseholdExpensesChartsDataProvider;
